/** API route map: URLS.Controller.ApplicationForms */
export const ApplicationForms = {
      Name: 'ApplicationForms/',
      GetById: 'get',
      GetAll: 'getAll',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
      MarkActive: 'mark-active',
      MarkDefault: 'mark-default',
      GetAllEmailCustomTemplates: 'get-all-email-custom-templates',
      UpdateEmailCustomTemplate: 'update-email-custom-template',
      DeleteEmailTemplate: 'delete-email-template',
      SaveMessageCustomTemplate: 'save-message-custom-template',
      GetAllMessageCustomTemplates: 'get-all-message-custom-templates',
      UpdateMessageCustomTemplate: 'update-message-custom-template',
      DeleteMessageTemplate: 'delete-message-template',
      SaveOfferLetterCustomTemplate: 'save-offer-letter-custom-template',
      GetAllOfferLetterCustomTemplates: 'get-all-offer-letter-custom-templates',
      UpdateOfferLetterCustomTemplate: 'update-offer-letter-custom-template',
      DeleteOfferLetterTemplate: 'delete-offer-letter-template',
      GetAllEmailTemplates: 'get-all-email-templates',
      GetAllMessageTemplates: 'get-all-message-templates',
      SaveEmailCustomTemplate: 'save-email-custom-template-candidate',
      SaveMessageCustomTemplateCandidate: 'save-message-custom-template-candidate',
      GetCandidateEmailTemplates: 'get-candidate-email-templates',
      GetCandidateMessageTemplates: 'get-candidate-message-templates',
};
